import gql from "graphql-tag";
import { ClientFragment, UserInfoFragment } from "./fragments";

export const GetUser = gql`
  query allUsers {
    allUsers {
      ...ClientInfo
    }
  }
  ${ClientFragment}
`;
export const AllCompanyUsersByClient = gql`
  query companyUsersByClient(
    $params: CompanyUserByClientFetchParams!
    $queries: CompanyUserByClientFetchQueries
  ) {
    companyUsersByClient(params: $params, queries: $queries) {
      data {
        companyUsers {
          ...UserInfo
        }
      }
    }
  }
  ${UserInfoFragment}
`;

export const CompanyUserById = gql`
  query companyUserById($id: ID!) {
    companyUserById(id: $id) {
      ...UserInfo
    }
  }
  ${UserInfoFragment}
`;
